<template>
  <div class="my-payments-alerts">
    <div class="page-subtitle" v-if="onboardingWarning" style="margin-top: 2em">
      Please check your
      <router-link to="/my-agreements">My Agreements</router-link> page to
      ensure you have completed all standard onboarding paperwork (MSA, W-9, ACH
      Authorization) and then return to this page to submit invoices.
      <br />
    </div>
    <div
      class="page-subtitle"
      v-if="currentMSAWarning"
      style="margin-top: 2em"
    >
      You have not completed an MSA for the current year. Please check your
      <router-link to="/my-agreements">My Agreements</router-link> page and sign
      the MSA before submitting an invoice for payment.
      <br />
    </div>
    <div
      class="page-subtitle"
      v-if="gaWithholdingWarning"
      style="margin-top: 2em"
    >
      You have a GA Film Tax Credit Withholding Acknowledgement out for
      signature. Please check your
      <router-link to="/my-agreements">My Agreements</router-link> page and
      sign it before submitting an invoice for payment.
      <br />
    </div>
    <div
      class="page-subtitle"
      v-if="w9SignatureWarning"
      style="margin-top: 2em"
    >
      You have an open W-9 form update request. Please check your
      <router-link to="/my-agreements">My Agreements</router-link> page to
      complete or cancel the form.
      <br />
    </div>
    <div
      class="page-subtitle"
      v-if="achSignatureWarning"
      style="margin-top: 2em"
    >
      You have an open ACH Authorization form update request. Please check
      your <router-link to="/my-agreements">My Agreements</router-link> page
      to complete or cancel the form.
      <br />
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    onboardingWarning() {
      if (!this.currentUser) return false;
      const onbDetails = this.currentUser.onboarding_details;
      return (
        !onbDetails.has_any_signed_msa ||
        onbDetails.w9_status != "SIGNED" ||
        onbDetails.ach_status != "SIGNED"
      );
    },
    currentMSAWarning() {
      if (!this.currentUser) return false;
      const onbDetails = this.currentUser.onboarding_details;
      return onbDetails.has_any_signed_msa && onbDetails.msa_status != "SIGNED";
    },
    gaWithholdingWarning() {
      if (!this.currentUser) return false;
      const onbDetails = this.currentUser.onboarding_details;
      return onbDetails.ga_withholding_status == "OUT_FOR_SIGNATURE";
    },
    w9SignatureWarning() {
      if (!this.currentUser) return false;
      const onbDetails = this.currentUser.onboarding_details;
      return onbDetails.w9_signature_needed;
    },
    achSignatureWarning() {
      if (!this.currentUser) return false;
      const onbDetails = this.currentUser.onboarding_details;
      return onbDetails.ach_signature_needed;
    },
  },
};
</script>
